import { render, staticRenderFns } from "./ShareDialogue.vue?vue&type=template&id=a8c9d3c8&scoped=true&"
import script from "./ShareDialogue.vue?vue&type=script&lang=js&"
export * from "./ShareDialogue.vue?vue&type=script&lang=js&"
import style0 from "./ShareDialogue.vue?vue&type=style&index=0&id=a8c9d3c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c9d3c8",
  null
  
)

export default component.exports